// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloseSquareTwoToneSvg from "@fishx/icons-svg/es/asn/CloseSquareTwoTone";
import FishxIcon from '../components/FishxIcon';

var CloseSquareTwoTone = function CloseSquareTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloseSquareTwoToneSvg
  }));
};

CloseSquareTwoTone.displayName = 'CloseSquareTwoTone';
export default React.forwardRef(CloseSquareTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CloseSquareTwoTone.js
// module id = 2246
// module chunks = 0